import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function ArrowIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      {...props}
    >
      <title>{_(msg`Arrow Icon`)}</title>
      <path
        d="M1.66675 6L13.6667 6"
        stroke="currentColor"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 1L13.6667 6L8.66675 11"
        stroke="currentColor"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
